import React, { Component } from 'react';
import { RichText } from 'prismic-reactjs';
import './style.css';
import portrait from './bio.jpg'

import { Watch } from 'scrollmonitor-react';
import AddAnimationClass from '../../shared/helpers/addAnimationClass';

export default Watch(class Services extends Component {
    firstTime = true;

    componentWillUpdate(nextProps) {
        if(typeof nextProps.content  !== 'undefined' && this.firstTime) {
            this.props.startWatcher();
            this.firstTime = false;
        }
    }

    componentDidUpdate(){
        if(this._container.classList.contains("loading") && !this.firstTime){
            this._container.classList.remove("loading");
        }
    }

    render() {
        let citation;
        let description;

        if (typeof this.props.content !== 'undefined') {
            citation = RichText.render(this.props.content.data.citation);
            description = RichText.render(this.props.content.data.description);
        }
        if (this.props.isInViewport) {
            AddAnimationClass(this._container, 200)
            this.props.stopWatcher();
        }

        return (
            <section id="bio" className="bio site-section loading" ref={(el) => { this._container = el; }}>
                <span className="decoration-line to-animate"></span>
                <div className="bio-intro">
                    <div className="wrapper">
                        <cite className="bio-quote to-animate">
                            {citation}
                        </cite>
                        <div className="bio-portrait to-animate" >
                            <img src={portrait} alt="Didier de Greef portrait" />
                        </div>
                    </div>
                    <span className="shape-container">
                        <svg width="100%" height="100%" viewBox="0 0 1277 149" version="1.1">
                            <polygon id="Path-80" points="0 150 1278 150 1278 0"></polygon>
                        </svg>
                    </span>
                </div>
                <div className="bio__content">
                    <div className="wrapper">
                        <h2 className="bio-name to-animate">Didier De Greef</h2>
                        <div className="bio-text to-animate">{description}</div>
                    </div>
                </div>
            </section>
        );
    }
});


// WEBPACK FOOTER //
// ./src/components/bio/index.js